export function splitArrayIntoGroups(array: any, groupSize: number) {
    const groups = [];
    for (let i = 0; i < array.length; i += groupSize) {
        groups.push(array.slice(i, i + groupSize));
    }
    return groups;
}

export function formatTimeAMPM(date?: string) {
    let _date = date ? new Date(date) :  new Date();

    let hours = _date.getHours();
    let minutes = _date.getMinutes();

    // Check whether AM or PM
    let newformat = hours >= 12 ? 'PM' : 'AM';

    // Find current hour in AM-PM Format
    hours = hours % 12;

    // To display "0" as "12"
    hours = hours ? hours : 12;

    return(hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ' ' + newformat);
}

export function base64ToBlob(base64: string, contentType = "",
    sliceSize = 512) {
    const byteCharacters = atob(base64.split(",")[1]);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length;
        offset += sliceSize) {
        const slice = byteCharacters.slice(
            offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
}

export function iOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.userAgent)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  export function iPhone() {
    return [
      'iPod Simulator',
      'iPhone',
      'iPod'
    ].includes(navigator.userAgent)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  export function getVideoThumb(url: string) {
    //
    if (url) {
      const link = url.split('https://res.cloudinary.com/')

      if (link.length > 0) {
        //
        return 'https://res.cloudinary.com/'+link[1].split('video/upload/')[0]+'video/upload/so_5,w_300,h_400,c_fill/'+(link[1].split('video/upload/')[1].split('.')[0])+'.png'

      } else {

        return ''
      }
    }
  }

  export function getMediaStreamURL(url: string) {
    //
    if (url) {
      const link = url.split('https://res.cloudinary.com/')
      if (link.length > 0) {
        //
        console.log(link[1])
        return 'https://res.cloudinary.com/'+( link[1].split( (link[1].includes('video/upload/') ? 'video/upload/' : 'image/upload/' ) )[0] )+(link[1].includes('video/upload/') ? 'video/upload/' : 'image/upload/' )+'f_auto:video,q_auto:eco/'+link[1].split((link[1].includes('video/upload/') ? 'video/upload/' : 'image/upload/' ))[1]
      } else {
        return ''
      }
    }
  }

  export function getMediaStreamVideoURL(url: string) {
    //
    if (url) {
      const link = url.split('https://res.cloudinary.com/dttxqjchu/video/upload/')
      if (link.length > 0) {
        return link[1].split('.')[0]
      } else {
        return ''
      }
    }
  }